module.exports = __webpack_public_path__ + "img/anima.79162abb.svg";